import { FormControlLabel, Switch } from "@mui/material";
import { useFormikContext } from "formik";


const FormikSwitch = ({ name, label, disabled }) => {
  const { setFieldValue, values } = useFormikContext();
  const handleChange = () => {
    setFieldValue(name, !values[name]);
  }

  return (
    <FormControlLabel
      control={
        <Switch
          name={name}
          checked={values[name]}
          onChange={handleChange}
          disabled={disabled}
        />
      }
      label={label}
      labelPlacement="start"
    />
  )
};

export default FormikSwitch;